<template>
    <div class="movie-entry-container">
      <!-- 页面标题 -->
      <div class="title-section">
        <div >
          <img src="static/image/logo.png" alt="logo" class="logo-section">
        </div>
        <h1>短片徵集報名表 Application form for soliciting short films</h1>
      </div>
    <el-form  :model="formData" label-position="top" label-width="120px" :rules="movieRules" ref="movieForm" style="margin-top: 10px;">
      
          <el-card class="box-card"> 
            <div slot="header" class="clearfix">
              <span>申報須知 </span>
              <span>Submission Guidelines</span>
            </div>
            <div class="form-section">
              <div v-html="agreement_content"></div>
              <div class="checkbox-group">
                
                <el-form-item  prop="agreed">
                  <el-checkbox v-model="agreed">
                    <div><span class='submission-font-red'>*</span> 我已閱讀規則並同意遵守。I have read the rules and agree to abide by them.</div>
                  </el-checkbox>
                </el-form-item>
              </div>
            </div>
          </el-card>
          <el-card class="box-card">
            <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="作品名稱 Film Title" prop="film_title">
                  <el-input v-model="formData.film_title"></el-input>
                </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                <el-form-item label="申報單位 Submitter (Organization)" prop="submitter">
                  <el-input v-model="formData.submitter" class="h-30"></el-input>
                </el-form-item>
                </el-col>
            </el-row>
          
            <el-row :gutter="20">
              <el-col :span="8">
                  <el-form-item label="聯絡人 Person of Contact" prop="contact">
                    <el-input v-model="formData.contact" placeholder="" class="h-30"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="聯絡電話 Contact Number" prop="phone">
                  <el-input v-model="formData.phone" placeholder="" class="h-30"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label="電子郵箱 Email" prop="email">
                    <el-input v-model="formData.email" placeholder="" class="h-30"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            
          </el-card>
         
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>短片資訊（此列需中英雙語填寫）</span>
              <span>Short film information（In both Chinese and English）</span>
            </div>
            <div>
              
              <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="片名 Title" prop="title">
                    <el-input v-model="formData.title"></el-input>
                  </el-form-item>
                  </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="短片類型 Film Type" prop="cate">
                  <el-input v-model="formData.cate"></el-input>
                </el-form-item>
                </el-col>
              </el-row>
              
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="國家/地區 Country/Region" prop="country">
                    <el-input v-model="formData.country"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="製作年份 Completion Year" prop="year_produced">
                    <el-input v-model="formData.year_produced"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
  
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="時  長 Runtime" prop="length">
                    <el-input v-model="formData.length" maxlength="10"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="短片語言 Short language" prop="language">
                    <el-input v-model="formData.language"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

            </div>
          </el-card>

  
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <p>演職人員信息 Cast and Crew</p>
              <p>請填寫姓名、上傳照片、上傳簡曆。Please enter the name and upload a photo and resume.</p>
            </div>
            <div>
              <!-- 导演 -->
              <div class="mb-10 f-14">導演 Director</div>
              <el-row :gutter="20">
                <el-col :span="6">
                      <div class="sub-title"><span class='font-red'>*</span>1. </div>
                      <div class="input-upload">
                        <el-form-item prop="director1">
                          <el-input v-model="formData.director1" placeholder="" maxlength="100"></el-input>
                        </el-form-item>
                        <el-form-item prop="director1_avatar" class="input-upload-avatar">
                          <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :before-upload="handleBeforeUpload"
                            accept="image/*"
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-change="handleFileChange"
                            :data="{'field':'director1_avatar'}"
                          >
                          <img v-if="formData.director1_avatar" :src="formData.director1_avatar" class="upload-img">
                          <i v-else class="el-icon-user upload-plus"><span class="font-red">*</span></i>
                          </el-upload>
                        </el-form-item>
                        
                        <el-form-item prop="director1_resume" class="input-upload-avatar">
                          <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :before-upload="handleBeforeUpload"
                            accept="file/*"
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-change="handleFileChange"
                            :data="{'field':'director1_resume'}"
                          >
                          <i v-if="formData.director1_resume" class="el-icon-circle-check upload-plus"></i>
                          <i v-else class="el-icon-document upload-plus"></i>
                          </el-upload>
                        </el-form-item>
                      </div>
                </el-col>
                <el-col :span="6">
                  <el-form-item>
                    <div class="sub-title">2.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.director2" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'director2_avatar'}"
                        >
                        <img v-if="formData.director2_avatar" :src="formData.director2_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'director2_resume'}"
                        >
                        <i v-if="formData.director2_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">3.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.director3" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'director3_avatar'}"
                        >
                        <img v-if="formData.director3_avatar" :src="formData.director3_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'director3_resume'}"
                        >
                        <i v-if="formData.director3_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">更多 More</div>
                      <div class="input-upload">
                        <el-input v-model="formData.director_more" placeholder="以逗號分隔 separate with comm" ></el-input>
                      </div>
                  </el-form-item>
                </el-col>
              </el-row>
  
              <div class="mb-10 f-14">編劇 Screenwriter</div>
              <el-row :gutter="20">
                <el-col :span="6">
                      <div class="sub-title"><span class='font-red'>*</span>1. </div>
                      <div class="input-upload">
                        <el-form-item prop="screenwriter1">
                          <el-input v-model="formData.screenwriter1" placeholder="" maxlength="100"></el-input>
                        </el-form-item>
                        <el-form-item prop="screenwriter1_avatar">
                          <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :before-upload="handleBeforeUpload"
                            accept="image/*"
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-change="handleFileChange"
                            :data="{'field':'screenwriter1_avatar'}"
                          >
                          <img v-if="formData.screenwriter1_avatar" :src="formData.screenwriter1_avatar" class="upload-img">
                          <i v-else class="el-icon-user upload-plus"><span class="font-red">*</span></i>
                          </el-upload>
                        </el-form-item>
                        <el-form-item prop="screenwriter1_resume">
                          <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :before-upload="handleBeforeUpload"
                            accept="file/*"
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-change="handleFileChange"
                            :data="{'field':'screenwriter1_resume'}"
                          >
                          <i v-if="formData.screenwriter1_resume" class="el-icon-circle-check upload-plus"></i>
                          <i v-else class="el-icon-document upload-plus"></i>
                          </el-upload>
                        </el-form-item>
                      </div>
                </el-col>
                <el-col :span="6">
                  <el-form-item>
                    <div class="sub-title">2.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.screenwriter2" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'screenwriter2_avatar'}"
                        >
                        <img v-if="formData.screenwriter2_avatar" :src="formData.screenwriter2_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'screenwriter2_resume'}"
                        >
                        <i v-if="formData.screenwriter2_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">3.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.screenwriter3" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'screenwriter3_avatar'}"
                        >
                        <img v-if="formData.screenwriter3_avatar" :src="formData.screenwriter3_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'screenwriter3_resume'}"
                        >
                        <i v-if="formData.screenwriter3_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">更多 More</div>
                      <div class="input-upload">
                        <el-input v-model="formData.screenwriter_more" placeholder="以逗號分隔 separate with comm" ></el-input>
                      </div>
                  </el-form-item>
                </el-col>
              </el-row>
  
              <div class="mb-10 f-14">演員 Actor</div>
              <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item prop="actor1">
                      <div class="sub-title"><span class='font-red'>*</span> 1. </div>
                      <div class="input-upload">
                        <el-input v-model="formData.actor1" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor1_avatar'}"
                        >
                        <img v-if="formData.actor1_avatar" :src="formData.actor1_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor1_resume'}"
                        >
                        <i v-if="formData.actor1_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item prop="actor2" >
                    <div class="sub-title"><span class='font-red'>*</span> 2. </div>
                      <div class="input-upload">
                        <el-input v-model="formData.actor2" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor2_avatar'}"
                        >
                        <img v-if="formData.actor2_avatar" :src="formData.actor2_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor2_resume'}"
                        >
                        <i v-if="formData.actor2_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">3.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.actor3" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor3_avatar'}"
                        >
                        <img v-if="formData.actor3_avatar" :src="formData.actor3_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor3_resume'}"
                        >
                        <i v-if="formData.actor3_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">4.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.actor4" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor4_avatar'}"
                        >
                        <img v-if="formData.actor4_avatar" :src="formData.actor4_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor4_resume'}"
                        >
                        <i v-if="formData.actor4_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item >
                      <div class="sub-title">5.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.actor5" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor5_avatar'}"
                        >
                        <img v-if="formData.actor5_avatar" :src="formData.actor5_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor5_resume'}"
                        >
                        <i v-if="formData.actor5_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item>
                    <div class="sub-title">6.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.actor6" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor6_avatar'}"
                        >
                        <img v-if="formData.actor6_avatar" :src="formData.actor6_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'actor6_resume'}"
                        >
                        <i v-if="formData.actor6_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col><el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">更多 More</div>
                    <el-input v-model="formData.actor_more" placeholder="以逗號分隔 separate with comm"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
  
              <div class="mb-10 f-14">製片人 Producer</div>
              <el-row :gutter="20">
                <el-col :span="6">
                      <div class="sub-title"><span class='font-red'>*</span>1. </div>
                      <div class="input-upload">
                        <el-form-item prop="producer1">
                          <el-input v-model="formData.producer1" placeholder="" maxlength="100"></el-input>
                        </el-form-item>
                        <el-form-item prop="producer1_avatar">
                          <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :before-upload="handleBeforeUpload"
                            accept="image/*"
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-change="handleFileChange"
                            :data="{'field':'producer1_avatar'}"
                          >
                          <img v-if="formData.producer1_avatar" :src="formData.producer1_avatar" class="upload-img">
                          <i v-else class="el-icon-user upload-plus"><span class="font-red">*</span></i>
                          </el-upload>
                        </el-form-item>
                        <el-form-item prop="producer1_resume">
                          <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :before-upload="handleBeforeUpload"
                            accept="file/*"
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-change="handleFileChange"
                            :data="{'field':'producer1_resume'}"
                          >
                          <i v-if="formData.producer1_resume" class="el-icon-circle-check upload-plus"></i>
                          <i v-else class="el-icon-document upload-plus"></i>
                          </el-upload>
                        </el-form-item>
                      </div>
                </el-col>
                <el-col :span="6">
                  <el-form-item>
                    <div class="sub-title">2.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.producer2" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'producer2_avatar'}"
                        >
                        <img v-if="formData.producer2_avatar" :src="formData.producer2_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'producer2_resume'}"
                        >
                        <i v-if="formData.producer2_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">3.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.producer3" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'producer3_avatar'}"
                        >
                        <img v-if="formData.producer3_avatar" :src="formData.producer3_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'producer3_resume'}"
                        >
                        <i v-if="formData.producer3_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">更多 More</div>
                      <div class="input-upload">
                        <el-input v-model="formData.producer_more" placeholder="以逗號分隔 separate with comm" ></el-input>
                      </div>
                  </el-form-item>
                </el-col>
              </el-row>
  
              <div class="mb-10 f-14">攝影 Cinematographer</div>
              <el-row :gutter="20">
                <el-col :span="6">
                      <div class="sub-title"><span class='font-red'>*</span>1. </div>
                      <div class="input-upload">
                        <el-form-item prop="cinematographer1">
                          <el-input v-model="formData.cinematographer1" placeholder="" maxlength="100"></el-input>
                        </el-form-item>
                        <el-form-item prop="cinematographer1_avatar">
                          <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :before-upload="handleBeforeUpload"
                            accept="image/*"
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-change="handleFileChange"
                            :data="{'field':'cinematographer1_avatar'}"
                          >
                          <img v-if="formData.cinematographer1_avatar" :src="formData.cinematographer1_avatar" class="upload-img">
                          <i v-else class="el-icon-user upload-plus"><span class="font-red">*</span></i>
                          </el-upload>
                        </el-form-item>
                        <el-form-item prop="cinematographer1_resume">
                          <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :before-upload="handleBeforeUpload"
                            accept="file/*"
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-change="handleFileChange"
                            :data="{'field':'cinematographer1_resume'}"
                          >
                          <i v-if="formData.cinematographer1_resume" class="el-icon-circle-check upload-plus"></i>
                          <i v-else class="el-icon-document upload-plus"></i>
                          </el-upload>
                        </el-form-item>
                      </div>
                </el-col>
                <el-col :span="6">
                  <el-form-item>
                    <div class="sub-title">2.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.cinematographer2" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'cinematographer2_avatar'}"
                        >
                        <img v-if="formData.cinematographer2_avatar" :src="formData.cinematographer2_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'cinematographer2_resume'}"
                        >
                        <i v-if="formData.cinematographer2_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">3.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.cinematographer3" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'cinematographer3_avatar'}"
                        >
                        <img v-if="formData.cinematographer3_avatar" :src="formData.cinematographer3_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'cinematographer3_resume'}"
                        >
                        <i v-if="formData.cinematographer3_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">更多 More</div>
                      <div class="input-upload">
                        <el-input v-model="formData.cinematographer_more" placeholder="以逗號分隔 separate with comm" ></el-input>
                      </div>
                  </el-form-item>
                </el-col>
              </el-row>
  
              <div class="mb-10 f-14">美術 Art</div>
              <el-row :gutter="20">
                <el-col :span="6">
                      <div class="sub-title"><span class='font-red'>*</span>1. </div>
                      <div class="input-upload">
                        <el-form-item prop="art1">
                          <el-input v-model="formData.art1" placeholder="" maxlength="100"></el-input>
                        </el-form-item>
                        <el-form-item prop="art1_avatar">
                          <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :before-upload="handleBeforeUpload"
                            accept="image/*"
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-change="handleFileChange"
                            :data="{'field':'art1_avatar'}"
                          >
                          <img v-if="formData.art1_avatar" :src="formData.art1_avatar" class="upload-img">
                          <i v-else class="el-icon-user upload-plus"><span class="font-red">*</span></i>
                          </el-upload>
                        </el-form-item>
                        <el-form-item prop="art1_resume">
                          <el-upload
                            class="avatar-uploader"
                            :action="upload_url"
                            :before-upload="handleBeforeUpload"
                            accept="file/*"
                            :show-file-list="false"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-change="handleFileChange"
                            :data="{'field':'art1_resume'}"
                          >
                          <i v-if="formData.art1_resume" class="el-icon-circle-check upload-plus"></i>
                          <i v-else class="el-icon-document upload-plus"></i>
                          </el-upload>
                        </el-form-item>
                      </div>
                </el-col>
                <el-col :span="6">
                  <el-form-item>
                    <div class="sub-title">2.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.art2" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'art2_avatar'}"
                        >
                        <img v-if="formData.art2_avatar" :src="formData.art2_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'art2_resume'}"
                        >
                        <i v-if="formData.art2_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">3.</div>
                      <div class="input-upload">
                        <el-input v-model="formData.art3" placeholder="" maxlength="100"></el-input>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="image/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'art3_avatar'}"
                        >
                        <img v-if="formData.art3_avatar" :src="formData.art3_avatar" class="upload-img">
                        <i v-else class="el-icon-user upload-plus"></i>
                        </el-upload>
                        <el-upload
                          class="avatar-uploader"
                          :action="upload_url"
                          :before-upload="handleBeforeUpload"
                          accept="file/*"
                          :show-file-list="false"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-change="handleFileChange"
                          :data="{'field':'art3_resume'}"
                        >
                        <i v-if="formData.art3_resume" class="el-icon-circle-check upload-plus"></i>
                        <i v-else class="el-icon-document upload-plus"></i>
                        </el-upload>
                      </div>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="">
                    <div class="sub-title">更多 More</div>
                      <div class="input-upload">
                        <el-input v-model="formData.art_more" placeholder="以逗號分隔 separate with comm" ></el-input>
                      </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-card>
          
          <el-card class="box-card">
            <el-row :gutter="20">
              <el-col :span="24">
              <el-form-item label="是否同意展映 Do you agree to have the film screened">
                <el-radio v-model="formData.screened" label="YES">同  意 Yes</el-radio>
                <el-radio v-model="formData.screened" label="NO">不同意 No</el-radio>
              </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
              <el-form-item label="字幕 Subtitles">
                <el-checkbox-group v-model="formData.subtitled">
                  <el-checkbox label="Chinese">中文 Chinese</el-checkbox>
                  <el-checkbox label="English">英文 English</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
              <el-form-item label="曾獲獎項 Previous Awards">
                <el-input type="textarea" :rows="3" v-model="formData.awards" placeholder=""></el-input>
              </el-form-item>
              </el-col>
            </el-row>
          </el-card>
          
          <el-card class="box-card"> 
            <!-- 单元类别信息 -->
            <div slot="header" class="clearfix">
              <span>報名選項</span>
              <span> Sections you wish to enter</span>
            </div>
            <div class="">
                <div>所有報名短片均視為亞洲藝術電影節的報名短片，具體專案的選擇僅為報名者傾向於報名的單元。短片最終入圍的單元由亞洲藝術電影節評審團決定。</div>
                <div >All submitted films will be considered as entries for the Asian Art Film Festival. The specific section(s) selected during registration reflect the applicant's preferred category(s). The final section in which a film is officially selected will be determined by the jury of the Asian Art Film Festival.</div>
            </div>
            <el-checkbox-group v-model="formData.unit_cate" >
                <div class="mt-10 font-size-12" v-for="(item, index) in unit_cate_list" :key="index">
                    <div class="mb-5">
                        <el-checkbox :label="item.cate" border>{{item.label}}</el-checkbox>
                        <div class="tips">{{item.tips_cn}}</div>
                        <div class="tips">{{item.tips_en}}</div>
                    </div>
                </div>
            </el-checkbox-group>
          </el-card>

          <el-card class="box-card"> 
            <div slot="header" class="clearfix">
              <span>短片簡介（300字以内）</span>
              <span>Brief Introduction of the Film</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="24">
                  <el-form-item label="中文 Chinese" prop="summary">
                  <el-input v-model="formData.summary" type="textarea" :rows="4"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                  <el-form-item label="英文 English" prop="description">
                  <el-input v-model="formData.description" type="textarea" :rows="4"></el-input>
                  </el-form-item>
              </el-col>
            </el-row>
          </el-card>

          <!-- 上傳片花 / 預告片、劇照及海報-->
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>上傳片花 / 預告片、劇照及海報</span>
              <span>Movie Uploads</span>
            </div>
            <div class="">
              <p>請在規定大小範圍內盡可能上傳清晰度高的圖片及影片。</p>
            </div>
    
            <!-- 海报 -->
            <el-form-item label="海報 2 張（豎版及橫版）(請至少上傳一張，每張海報大小在 5 MB以內) Posters (Size Limit: 5 MB)" prop="poster1">
                <div class="upload-buttons">
    
                  <el-upload
                    :action="upload_url"
                    :before-upload="handleBeforeUpload"
                    accept="image/*"
                    :show-file-list="false"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :on-change="handleFileChange"
                    :data="{'field':'poster1'}"
                  >
                    <img v-if="formData.poster1" :src="formData.poster1" class="multi-uploader-img">
                    <div v-else class="multi-uploader"><span class="font-red font-size-20">*</span><i class="el-icon-plus "></i></div>
                  </el-upload>
    
                  <el-upload
                    :action="upload_url"
                    :before-upload="handleBeforeUpload"
                    accept="image/*"
                    :show-file-list="false"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :on-change="handleFileChange"
                    :data="{'field':'poster2'}"
                  >
                    <img v-if="formData.poster2" :src="formData.poster2" class="multi-uploader-img">
                    <i v-else class="el-icon-plus multi-uploader"></i>
                  </el-upload>
    
                </div>
            </el-form-item>
    
            <!-- 剧照 -->
    
            <div class="mb-10 f-14"><span class="font-red">*</span> 劇照 (請至少上傳三張，每張劇照大小在 5 MB以內)  Film stills (size Limit: 5 MB)</div>
            
                <div class="upload-buttons">
                  <el-form-item prop="stils1">
                    <el-upload
                      :action="upload_url"
                      :before-upload="handleBeforeUploadLimit5M"
                      accept="image/*"
                      :show-file-list="false"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :on-change="handleFileChange"
                      :data="{'field':'stils1'}"
                    >
                      <img v-if="formData.stils1" :src="formData.stils1" class="multi-uploader-img">
                      <div v-else class="multi-uploader"><span class="font-red font-size-20">*</span><i class="el-icon-plus "></i></div>
                    </el-upload>
                  </el-form-item>
    
                  <el-form-item prop="stils2">
                    <el-upload
                      :action="upload_url"
                      :before-upload="handleBeforeUploadLimit5M"
                      accept="image/*"
                      :show-file-list="false"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :on-change="handleFileChange"
                      :data="{'field':'stils2'}"
                    >
                      <img v-if="formData.stils2" :src="formData.stils2" class="multi-uploader-img">
                      <div v-else class="multi-uploader"><span class="font-red font-size-20">*</span><i class="el-icon-plus "></i></div>
                    </el-upload>
                  </el-form-item>
    
                  <el-form-item prop="stils3">
                    <el-upload
                      :action="upload_url"
                      :before-upload="handleBeforeUploadLimit5M"
                      accept="image/*"
                      :show-file-list="false"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :on-change="handleFileChange"
                      :data="{'field':'stils3'}"
                    >
                      <img v-if="formData.stils3" :src="formData.stils3" class="multi-uploader-img">
                      <div v-else class="multi-uploader"><span class="font-red font-size-20">*</span><i class="el-icon-plus "></i></div>
                    </el-upload>
                  </el-form-item>
    
                  <el-form-item prop="stils4">
                    <el-upload
                      :action="upload_url"
                      :before-upload="handleBeforeUploadLimit5M"
                      accept="image/*"
                      :show-file-list="false"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :on-change="handleFileChange"
                      :data="{'field':'stils4'}"
                    >
                      <img v-if="formData.stils4" :src="formData.stils4" class="multi-uploader-img">
                      <i v-else class="el-icon-plus multi-uploader"></i>
                    </el-upload>
                  </el-form-item>
    
                  <el-form-item prop="stils5">
                    <el-upload
                      :action="upload_url"
                      :before-upload="handleBeforeUploadLimit5M"
                      accept="image/*"
                      :show-file-list="false"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :on-change="handleFileChange"
                      :data="{'field':'stils5'}"
                    >
                      <img v-if="formData.stils5" :src="formData.stils5" class="multi-uploader-img">
                      <i v-else class="el-icon-plus multi-uploader"></i>
                    </el-upload>
                  </el-form-item>
    
                  <el-form-item prop="stils6">
                    <el-upload
                      :action="upload_url"
                      :before-upload="handleBeforeUploadLimit5M"
                      accept="image/*"
                      :show-file-list="false"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :on-change="handleFileChange"
                      :data="{'field':'stils6'}"
                    >
                      <img v-if="formData.stils6" :src="formData.stils6" class="multi-uploader-img">
                      <i v-else class="el-icon-plus multi-uploader"></i>
                    </el-upload>
                  </el-form-item>
                </div>
    
            <!-- 片花/预告片 -->
            <!-- <el-form-item label="短片片花 30秒以内精剪（MP4格式，1080p，無水印） Short film trailer: 30 seconds or less (MP4 format, 1080p, no watermark)" prop="trailer">
              <div class="">
                <video v-if="formData.trailer" height="200" controls :src="formData.trailer" preload="metadata" currentTime="0">
                </video>
                <el-upload
                  :action="large_upload_url"
                  :on-change="handleTrailerUpload"
                  :before-upload="handleBeforeUploadLimit500M"
                  accept="video/*"
                  :on-exceed="handleExceed"
                  :show-file-list="false"
                  :auto-upload="false"
                  :data="{'field':'trailer'}"
                >
                  <el-button size="middle" plain type="primary"><span class="font-red ">*</span> 點擊上傳</el-button>
                </el-upload>
              </div>
              显示上传进度
              <div v-if="uploadProgress.trailer && uploadProgress.trailer.status !== 'success'" class="upload-progress">
                <el-progress
                  :percentage="uploadProgress.trailer.percentage">
                </el-progress>
              </div>
            </el-form-item> -->
            <el-form-item label="片花/預告片鏈接 Trailer / Teaser Link" prop="trailer_link">
                <div class="sub-title">請填寫可下載的分享鏈接（百度網盤、Vimeo、Google Drive 均可），僅供評審使用。</div>
                <div class="sub-title">Please provide a downloadable sharing link (via Baidu Netdisk, Vimeo, or Google Drive). This material is for review purposes only.</div>
                
                <el-input v-model="formData.trailer_link"></el-input>
            </el-form-item>
            
            <!-- 正片 -->
            <!-- <el-form-item label="短片成片（MP4格式，1080p） Short film (MP4, 1080p)" prop="full_movie">
              <div class="">
                <video v-if="formData.full_movie" height="200" controls :src="formData.full_movie" preload="metadata" currentTime="0">
                </video>
                <el-upload
                  :action="large_upload_url"
                  :on-change="handleFullMovieUpload"
                  :before-upload="handleBeforeUploadLimit5G"
                  accept="video/*"
                  :on-exceed="handleExceed"
                  :show-file-list="false"
                  :auto-upload="false"
                  :data="{'field':'full_movie'}"
                >
                  <el-button size="middle" plain type="primary"><span class="font-red ">*</span> 點擊上傳</el-button>
                </el-upload>
              </div>
              <div v-if="uploadProgress.full_movie && uploadProgress.full_movie.status !== 'success'" class="upload-progress">
                <el-progress
                  :percentage="uploadProgress.full_movie.percentage">
                </el-progress>
              </div>
            </el-form-item> -->
            <el-form-item label="短片成片鏈接 Short film Video Link" prop="movie_link">
              <div class="sub-title">請填寫可下載的分享鏈接（百度網盤、Vimeo、Google Drive 均可），僅供評審使用。</div>
              <div class="sub-title">Please provide a downloadable sharing link (via Baidu Netdisk, Vimeo, or Google Drive). This material is for review purposes only.</div>
              
              <el-input v-model="formData.movie_link"></el-input>
            </el-form-item>

          </el-card>
  
          <el-card class="box-card"> 
            <el-form-item label="承諾書 Pledge" prop="pledge">
              <div class="sub-title">請下载承諾書，打印、簽名並加蓋出品单位公章後，拍照上傳。</div>
              <div class="sub-title">Please download and print out Submission Agreement, sign it, and stamp it with the production company's official seal, then upload a photo of it.</div>
              <div class="pledge-buttons">
  
                <el-upload
                  :action="upload_url"
                  :before-upload="handleBeforeUpload"
                  accept="image/*"
                  :show-file-list="false"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :on-change="handleFileChange"
                  list-type="picture-card"
                  :data="{'field':'pledge'}"
                >
                  <img v-if="formData.pledge" :src="formData.pledge" class="business-uploader">
                  <i v-else class="el-icon-plus"></i>
                </el-upload>
              </div>
              <el-link type="primary" :underline="false" target="_blank" @click="downloadPledge" >下載承諾書 Download Submission Agreement</el-link>
            </el-form-item>
          </el-card>
    </el-form>
      <!-- 提交按钮 -->
      <div class="submit-buttons">
        <el-button type="primary" disabled>保存進度 Save Progress</el-button>
        <el-button type="success" disabled>確認提交 Submit</el-button>
      </div>
      <div class="footer">
        <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025494802号-1</a>
      </div>
    </div>
  </template>
  
  <script>
  import setting from '@/setting'
  import md5 from 'js-md5'
  export default {
    name: 'ShortFilmEntry',
    data () {
      return {
        activeCollapse: '0',
        agreed: false,
        formData: {
          film_title:'',
          submitter:'',
          title: '',
          cate: '',
          country: '',
          language: '',
          year_produced: '',
          length: '',
          summary: '',
          description: '',
          executive_producer1: '',
          executive_producer1_avatar: '',
          executive_producer2: '',
          executive_producer2_avatar: '',
          executive_producer3: '',
          executive_producer3_avatar: '',
          executive_producer_more: '',
          director1: '',
          director1_avatar: '',
          director2: '',
          director2_avatar: '',
          director3: '',
          director3_avatar: '',
          director_more: '',
          screenwriter1: '',
          screenwriter1_avatar: '',
          screenwriter2: '',
          screenwriter2_avatar: '',
          screenwriter3: '',
          screenwriter3_avatar: '',
          screenwriter_more: '',
          actor1: '',
          actor1_avatar: '',
          actor2: '',
          actor2_avatar: '',
          actor3: '',
          actor3_avatar: '',
          actor4: '',
          actor4_avatar: '',
          actor5: '',
          actor5_avatar: '',
          actor6: '',
          actor6_avatar: '',
          actor_more: '',
          producer1: '',
          producer1_avatar: '',
          producer2: '',
          producer2_avatar: '',
          producer3: '',
          producer3_avatar: '',
          producer_more: '',
          cinematographer1: '',
          cinematographer1_avatar: '',
          cinematographer2: '',
          cinematographer2_avatar: '',
          cinematographer3: '',
          cinematographer3_avatar: '',
          cinematographer_more: '',
          art1: '',
          art1_avatar: '',
          art2: '',
          art2_avatar: '',
          art3: '',
          art3_avatar: '',
          art_more: '',
          contact: '',
          phone: '',
          email: '',
          business_license: '',
          pledge: '',
          poster1: '',
          poster2: '',
          stils1: '',
          stils2: '',
          stils3: '',
          stils4: '',
          stils5: '',
          stils6: '',
          trailer: '',
          full_movie: '',
          unit_cate:[],
          screened:'YES',
          subtitled:[],
          awards: '',
          trailer_link:'',
          movie_link:'',
        },
        uploads: {},
        largeFileUploadStatus: '',
        movieRules: {
          // agreed: [{ required: true, message: '請閱讀申報須知並同意遵守', trigger: 'change' }],
          title: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        //   cate: [{ required: true, message: '請輸入類型', trigger: 'blur' }],
        //   country: [{ required: true, message: '請輸入國家/地區', trigger: 'blur' }],
        //   language: [{ required: true, message: '請輸入語言', trigger: 'blur' }],
        // //   subtitled: [{ required: true, message: '請輸入是否有字幕', trigger: 'blur' }],
        //   year_produced: [{ required: true, message: '請輸入製作年份', trigger: 'blur' }],
        //   length: [{ required: true, message: '請輸入時長', trigger: 'blur' }],
        //   summary: [{ required: true, message: '請輸入中文短片簡介', trigger: 'blur' }],
        //   description: [{ required: true, message: '請輸入英文短片簡介', trigger: 'blur' }],
        //   // company: [{ required: true, message: '請輸入出品單位', trigger: 'blur' }],
        //   contact: [{ required: true, message: '請輸入聯絡人', trigger: 'blur' }],
        //   phone: [{ required: true, message: '請輸入聯絡電話', trigger: 'blur' }],
        //   email: [{ required: true, message: '請輸入Email', trigger: 'blur' }],
        //   // business_license: [{ required: true, message: '請上傳營業執照', trigger: 'change' }],
        //   pledge: [{ required: true, message: '請上傳承諾書照片', trigger: 'change' }],
        //   // executive_producer1: [{ required: true, message: '請輸入出品人姓名', trigger: 'blur' }],
        //   // executive_producer1_avatar: [{ validator:this.validateImage, message: '請上傳', trigger: 'change' }],
        //   actor1: [{ required: true, message: '請填寫演員姓名', trigger: 'blur' }],
        //   actor1_avatar: [{ validator:this.validateImage, message: '請上傳', trigger: 'change' }],
        //   actor2: [{ required: true, message: '請填寫演員姓名', trigger: 'blur' }],
        //   actor2_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        //   director1: [{ required: true, message: '請輸入導演姓名', trigger: 'blur' }],
        //   director1_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        //   screenwriter1: [{ required: true, message: '請輸入編劇姓名和', trigger: 'blur' }],
        //   screenwriter1_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        //   producer1: [{ required: true, message: '請輸入製作人姓名', trigger: 'blur' }],
        //   producer1_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        //   cinematographer1: [{ required: true, message: '請輸入攝影姓名', trigger: 'blur' }],
        //   cinematographer1_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        //   art1: [{ required: true, message: '請輸入美術姓名', trigger: 'blur' }],
        //   art1_avatar: [{ required: true, message: '請上傳', trigger: 'change' }],
        //   poster1: [{ required: true, message: '請上傳1張海報', trigger: 'change' }],
        //   stils1: [{ required: true, message: '請上傳3張劇照', trigger: 'change' }],
        //   stils2: [{ required: true, message: '請上傳3張劇照', trigger: 'change' }],
        //   stils3: [{ required: true, message: '請上傳3張劇照', trigger: 'change' }],
        //   trailer: [{ required: true, message: '請上傳片花', trigger: 'change' }],
        //   full_movie: [{ required: true, message: '請上傳正片', trigger: 'change' }],
          
        },
        upload_url: setting.apiBaseURL + '/upload',
        large_upload_url: setting.apiBaseURL + '/large_upload',
        agreement_info_url: setting.apiBaseURL + '/agreement/info',
        uploadChunks: {}, // 用于存储分片上传的信息
        uploadProgress: {}, // 上传进度
        agreement_content:'',
        full_movie_url:'',
        unit_cate_list:[
            { cate: 'Feature_film', label: '剧情片單元 Feature film unit',tips_cn: '',tips_en:'' },
            { cate: 'Documentary', label: '纪录片單元 Documentary unit',tips_cn: '',tips_en:'' },
            { cate: 'Experimental_film', label: '实验片單元 Experimental film unit',tips_cn: '',tips_en:'' },
            { cate: 'Art-creative_film', label: '艺术创意片單元 Art-creative film unit',tips_cn: '',tips_en:'' },
            { cate: 'Cartoon', label: '动画片單元 Cartoon unit',tips_cn: '',tips_en:'' },
            { cate: 'Music', label: '音乐片單元 Music units',tips_cn: '',tips_en:'' },
            { cate: 'Artists_Jury_Special_Award', label: '评审团大奖 Artists’Jury Special Award',tips_cn: '',tips_en:'' },
        ]
      }
    },
    // 页面创建时恢复数据
    created () {
      this.loadFormDataFromLocalStorage()
      document.title = '亞洲藝術電影節短劇申報';
      this.getAgreementInfo()
    },
    // 监听 formData 变化并保存到 localStorage
    watch: {
      formData: {
        handler (newFormData) {
          this.saveFormDataToLocalStorage()
        },
        deep: true // 深度监听对象内部变化
      },
      agreed: {
        handler (newAgreed) {
          this.saveAgreedToLocalStorage()
        }
      },
      activeCollapse: {
        handler (newActiveCollapse) {
          this.saveActiveCollapseToLocalStorage()
        }
      }
    },
    methods: {
      validateImage(rule, value, callback) {
        if (!value) { // 如果value为空，即没有文件被选中上传
            return callback(new Error('请上传')); // 返回错误信息
        } else {
            callback(); // 通过验证
        }
      },
      addMember (type) {
        this.formData[type].push({ name: '' })
      },
      removeMember (type, index) {
        if (this.formData[type].length > 1) {
          this.formData[type].splice(index, 1)
        }
      },
      handleSuccess (rep, file, fileList) {
        console.log('handleSuccess')
        console.log(rep, file, fileList)
        if (typeof rep !== 'undefined' && typeof rep.status !== 'undefined' && rep.status === 200) {
          if (typeof rep.data.field !== 'undefined' && rep.data.url) {
            this.$set(this.formData, rep.data.field, rep.data.url)
          }
        }
      },
      handleAvatarSuccess (rep, file, fileList) {
        console.log('handleAvatarSuccess')
        console.log(rep, file, fileList)
      },
  
      handleError (err, file, fileList) {
        console.log(err, file, fileList)
      },
      handleFileChange (file, fileList) {
        console.log('handleFileChange', file)
        console.log(file, fileList)
        // const input = ''// event.target
        // if (input.files && input.files[0]) {
        //   this.formData[field] = input.files[0]
        // }
      },
      handleBeforeUpload (file) {
        if (file.size > 10 * 1024 * 1024) {
          this.$message.error('文件大小不能超過10MB')
          return false
        }
      },
      handleBeforeUploadLimit5M (file) {
        if (file.size > 10 * 1024 * 1024) {
          this.$message.error('文件大小不能超過10MB')
          return false
        }
      },
      handleBeforeUploadLimit500M (file) {
        if (file.size > 500 * 1024 * 1024) {
          this.$message.error('文件大小不能超過500MB')
          return false
        }
      },
      handleBeforeUploadLimit5G (file) {
        if (file.size > 5 * 1024 * 1024 * 1024) {
          this.$message.error('文件大小不能超過5GB')
          return false
        }
      },
      handleExceed (file, fileList) {
        this.$message.warning('只能上传一个文件')
      },
      downloadPledge () {
        window.open(setting.apiBaseURL+'/download/short_film/letter','blank');
      },
      saveProgress () {
        this.saveFormDataToLocalStorage()
        this.$message.success('已保存當前進度')
      },
      // 保存 formData 到 localStorage
      saveFormDataToLocalStorage () {
        try {
          const formDataToSave = { ...this.formData }
          // 过滤掉可能无法序列化的属性（如文件对象等）
          localStorage.setItem('shortFilmEntry_formData', JSON.stringify(formDataToSave))
        } catch (error) {
          console.error('保存 formData 到 localStorage 失败:', error)
        }
      },
      // 从 localStorage 加载 formData
      loadFormDataFromLocalStorage () {
        try {
          const savedFormData = localStorage.getItem('shortFilmEntry_formData')
          if (savedFormData) {
            const parsedData = JSON.parse(savedFormData)
            // 合并保存的数据到当前 formData
            Object.assign(this.formData, parsedData)
            this.full_movie_url = parsedData.full_movie
          }
  
          // 加载其他保存的状态
          const savedAgreed = localStorage.getItem('shortFilmEntry_agreed')
          if (savedAgreed !== null) {
            this.agreed = savedAgreed === 'true'
          }
  
          const savedActiveCollapse = localStorage.getItem('shortFilmEntry_activeCollapse')
          if (savedActiveCollapse) {
            this.activeCollapse = savedActiveCollapse
          }
        } catch (error) {
          console.error('从 localStorage 加载数据失败:', error)
        }
      },
  
      // 保存 agreed 状态到 localStorage
      saveAgreedToLocalStorage () {
        try {
          localStorage.setItem('shortFilmEntry_agreed', this.agreed.toString())
        } catch (error) {
          console.error('保存 agreed 到 localStorage 失败:', error)
        }
      },
  
      // 保存 activeCollapse 状态到 localStorage
      saveActiveCollapseToLocalStorage () {
        try {
          localStorage.setItem('shortFilmEntry_activeCollapse', this.activeCollapse)
        } catch (error) {
          console.error('保存 activeCollapse 到 localStorage 失败:', error)
        }
      },
  
      // 清除 localStorage 中保存的数据
      clearLocalStorage () {
        try {
          localStorage.removeItem('shortFilmEntry_formData')
          localStorage.removeItem('shortFilmEntry_agreed')
          localStorage.removeItem('shortFilmEntry_activeCollapse')
        } catch (error) {
          console.error('清除 localStorage 数据失败:', error)
        }
      },
      submitEntry () {
        if (!this.agreed) {
          this.$message.error('請閱讀申報須知並同意遵守。')
          return
        }
  
        // 校验所有表单
        // this.$refs.movieForm.validate(valid => {
        //   if (!valid) return ''
        // })
        this.$refs.movieForm.validate((valid) => {
          if (!valid) {
            // this.$message.error('請完善必填信息！')
            this.$message.error('請輸入片名')
            return
          }
  
          // if (this.uploadProgress.trailer && this.uploadProgress.trailer.status !== 'success') {
          //   this.$message.error('請等待片花/預告片上傳完成！')
          //   return
          // }
          // 显示提交确认对话框
          this.$confirm('確認提交申請資料嗎？提交後將無法修改。 <br>   Do you want to confirm and submit your application? Please note that it cannot be modified once submitted.', '確認提交 Confirm Submission', {
            confirmButtonText: '確認 Confirm',
            cancelButtonText: '取消 Cancel',
            type: 'warning',
            dangerouslyUseHTMLString: true
          }).then(() => {
            // 用户点击确认
            this.processSubmit()
          }).catch(() => {
            // return
          })
        })
      },
      async processSubmit () {
        // 显示加载状态
        const loading = this.$loading({
          lock: true,
          text: '資料提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        try {
          
          // 发送提交请求
          const response = await fetch(`${setting.apiBaseURL}/submit_short_film`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.formData)
          })
          const result = await response.json()
          // 关闭加载状态
          loading.close()
  
          if (result.status==200) {
            // 提交成功
            this.$message.success('申請資料提交成功。Submission Successful.')
            // 清除本地存储的数据
            this.clearLocalStorage()
            // 可以选择跳转到成功页面或重置表单
            // this.$router.push('/success')
            // 或者重置表单
            // this.resetForm()
          } else {
            // 提交失败
            this.$message.error(result.msg || '提交失敗，請稍後重試。Submission Failed. Please try again later.')
          }
        } catch (error) {
          // 关闭加载状态
          if (loading) {
            loading.close()
          }
          console.error('提交失敗:', error)
          this.$message.error('提交失敗，請檢查網絡連接後重試。Submission Failed. Please check your network connection and try again later.')
        }
      },
      async handleFullMovieUpload (file, fileList) {
        console.log('开始处理大文件上传', file)
  
        // 检查文件大小
        if (file.size > 5 * 1024 * 1024 * 1024) {
          this.$message.error('文件大小不能超過5GB')
          return false
        }
  
        const fieldName = 'full_movie'
  
        // 初始化上传进度
        this.$set(this.uploadProgress, fieldName, {
          percentage: 0,
          uploadedChunks: 0,
          totalChunks: 0,
          status: ''
        })
        console.log('this.uploadProgress 1', this.uploadProgress)
  
        try {
          // 开始分片上传
          await this.startChunkedUpload(file.raw || file, fieldName)
        } catch (error) {
          console.error('上傳失敗:', error)
          this.$set(this.uploadProgress, fieldName, {
            percentage: 0,
            uploadedChunks: 0,
            totalChunks: 0,
            status: 'exception'
          })
          this.$message.error('上傳失敗: ' + error.message)
        }
      },
      async handleTrailerUpload (file, fileList) {
        console.log('开始处理片花文件上传', file)
  
        // 检查文件大小
        if (file.size > 500 * 1024 * 1024) {
          this.$message.error('文件大小不能超過500MB')
          return false
        }
  
        const fieldName = 'trailer'
  
        // 初始化上传进度
        this.$set(this.uploadProgress, fieldName, {
          percentage: 0,
          uploadedChunks: 0,
          totalChunks: 0,
          status: ''
        })
        console.log('this.uploadProgress 1', this.uploadProgress)
  
        try {
          // 开始分片上传
          await this.startChunkedUpload(file.raw || file, fieldName)
        } catch (error) {
          console.error('上传失败:', error)
          this.$set(this.uploadProgress, fieldName, {
            percentage: 0,
            uploadedChunks: 0,
            totalChunks: 0,
            status: 'exception'
          })
          this.$message.error('上传失败1: ' + error.message)
        }
      },
      // 分片上传主逻辑
      async startChunkedUpload (file, fieldName) {
        const chunkSize = 2 * 1024 * 1024 // 2MB 每块
        const fileSize = file.size
        const totalChunks = Math.ceil(fileSize / chunkSize)
        console.log('totalChunks', totalChunks)
        // 更新进度信息
        this.$set(this.uploadProgress, fieldName, {
          percentage: 0,
          uploadedChunks: 0,
          totalChunks: totalChunks,
          status: ''
        })
        console.log('this.uploadProgress', this.uploadProgress)
  
        this.largeFileUploadStatus = `开始上传，共 ${totalChunks} 块`
  
        // 生成文件唯一标识
        const fileId = this.generateFileId(file)
  
        // 存储上传信息
        this.$set(this.uploadChunks, fileId, {
          chunks: [],
          uploadedChunks: 0,
          totalChunks: totalChunks
        })
  
        try {
          // 1. 先通知服务器准备接收文件
          const initResponse = await this.initiateUpload(file, fieldName, fileId, totalChunks)
  
          if (!initResponse.success) {
            throw new Error('初始化上传失败')
          }
  
          // 2. 逐个上传分片
          for (let i = 0; i < totalChunks; i++) {
            const start = i * chunkSize
            const end = Math.min(start + chunkSize, fileSize)
            const chunk = file.slice(start, end)
  
            // 上传单个分片
            await this.uploadChunk(chunk, i, fileId, fieldName, file)
  
            // 更新进度
            const uploadedChunks = i + 1
            const percentage = Math.round((uploadedChunks / totalChunks) * 10000)/100
            console.log('percentage:', percentage, uploadedChunks, totalChunks)
            this.$set(this.uploadProgress, fieldName, {
              percentage: percentage,
              uploadedChunks: uploadedChunks,
              totalChunks: totalChunks,
              status: ''
            })
  
            this.largeFileUploadStatus = `已上传 ${uploadedChunks}/${totalChunks} 块 (${percentage}%)`
          }
  
          // 3. 通知服务器合并文件
          const mergeResponse = await this.mergeChunks(fileId, fieldName, file.name, file.size)
  
          if (mergeResponse.success) {
            this.$set(this.uploadProgress, fieldName, {
              percentage: 100,
              uploadedChunks: totalChunks,
              totalChunks: totalChunks,
              status: 'success'
            })
  
            this.largeFileUploadStatus = '上传完成！'
  
            // 保存文件URL到formData
            this.$set(this.formData, fieldName, mergeResponse.url || mergeResponse.data.uri)
            if(fieldName == 'full_movie'){
              this.full_movie_url = mergeResponse.data.url
            }
            
  
            this.$message.success(`${file.name} 上传成功！`)
          } else {
            throw new Error('文件合并失败')
          }
        } catch (error) {
          this.$set(this.uploadProgress, fieldName, {
            percentage: 0,
            uploadedChunks: 0,
            totalChunks: totalChunks,
            status: 'error'
          })
  
          this.largeFileUploadStatus = '上传失败2: ' + error.message
          throw error
        }
      },
  
      // 初始化上传
      async initiateUpload (file, fieldName, fileId, totalChunks) {
        const formData = new FormData()
        formData.append('action', 'init')
        formData.append('fileId', fileId)
        formData.append('fileName', file.name)
        formData.append('fileSize', file.size)
        formData.append('totalChunks', totalChunks)
        formData.append('fieldName', fieldName)
  
        try {
          const response = await fetch(this.large_upload_url, {
            method: 'POST',
            body: formData
          })
  
          return await response.json()
        } catch (error) {
          throw new Error('初始化上传失败2: ' + error.message)
        }
      },
  
      // 上传单个分片
      async uploadChunk (chunk, chunkIndex, fileId, fieldName, file) {
        return new Promise((resolve, reject) => {
          const formData = new FormData()
          formData.append('action', 'upload')
          formData.append('fileId', fileId)
          formData.append('chunkIndex', chunkIndex)
          formData.append('chunk', chunk)
          formData.append('fileName', file.name)
          formData.append('fieldName', fieldName)
  
          const xhr = new XMLHttpRequest()
  
          xhr.upload.addEventListener('progress', (e) => {
            if (e.lengthComputable) {
              const chunkProgress = Math.round((e.loaded / e.total) * 100)
              // console.log(`分片 ${chunkIndex + 1} 上传进度: ${chunkProgress}%`)
              // let uploadProgress = this.uploadProgress[fieldName]
              // uploadProgress.percentage = uploadProgress.percentage+'.'+chunkProgress
              // this.$set(this.uploadProgress, fieldName, uploadProgress)
            }
          })
  
          xhr.addEventListener('load', () => {
            if (xhr.status === 200) {
              try {
                const response = JSON.parse(xhr.responseText)
                if (response.success) {
                  resolve(response)
                } else {
                  reject(new Error(response.message || '分片上传失败'))
                }
              } catch (e) {
                reject(new Error('解析响应失败'))
              }
            } else {
              reject(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`))
            }
          })
  
          xhr.addEventListener('error', () => {
            reject(new Error('网络错误'))
          })
  
          xhr.open('POST', this.large_upload_url)
          xhr.send(formData)
        })
      },
  
      // 合并分片
      async mergeChunks (fileId, fieldName, fileName, fileSize) {
        const formData = new FormData()
        formData.append('action', 'merge')
        formData.append('fileId', fileId)
        formData.append('fileName', fileName)
        formData.append('fileSize', fileSize)
        formData.append('fieldName', fieldName)
  
        try {
          const response = await fetch(this.large_upload_url, {
            method: 'POST',
            body: formData
          })
  
          return await response.json()
        } catch (error) {
          throw new Error('合并文件失败3: ' + error.message)
        }
      },
  
      // 生成文件唯一标识
      generateFileId (file) {
        const timestamp = new Date().getTime()
        const random = Math.random().toString(36).substr(2, 9)
        const file_name = md5(file.name)
        return `${file_name}_${file.size}_${timestamp}_${random}`
      },
  
      // 暂停上传
      pauseUpload (fieldName) {
        // 实际项目中需要实现暂停逻辑
        this.$message.info('暂停上传功能待实现')
      },
  
      // 恢复上传
      resumeUpload (fieldName) {
        // 实际项目中需要实现恢复逻辑
        this.$message.info('恢复上传功能待实现')
      },
  
      // 取消上传
      cancelUpload (fieldName) {
        // 实际项目中需要实现取消逻辑
        this.$message.info('取消上传功能待实现')
      },
      getAgreementInfo() { 
          const response = this.request(this.agreement_info_url,"POST",{type:'4'})
          response.then(data=>{
            if(data.status == 200){
              this.agreement_content = data.data.content
            }
          }).catch(error=>{
            console.log('error',error)
          })
      },
      async request(url,method,data){
        try {
          const response = await fetch(url, {
            method: method,
            headers: {
              'Content-Type': 'application/json' // 设置内容类型为JSON
            },
            body: JSON.stringify(data)
          })
          return await response.json()
        } catch (error) {
          throw new Error('request error: ' + error.message)
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .movie-entry-container {
    font-family: Arial, sans-serif;
    background-color: white;
    color: #333;
    padding: 20px;
    text-align: left;
    max-width: 1000px;
    margin: 0 auto;
    font-size: 14px;
  }
  
  .title-section {
    display: flex;
    justify-content: flex-start;
    text-align: left;
    margin-bottom: 20px;
    gap: 15px;
    height: 50px;
    line-height: 50px;
  }
  
  .title-section h1 {
    font-size: 1em;
    margin: 0;
  }
  
  .title-section p {
    font-size: 1em;
    margin: 5px 0 0 0;
    color: #666;
  }
  
  .form-section {
    margin-bottom: 20px;
  }
  
  .upload-instructions {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f8f9fa;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .upload-section {
    margin-bottom: 20px;
  }
  
  .upload-buttons {
    display: flex;
    gap: 10px;
    margin-top: 10px;
  }
  
  .pledge-buttons {
    /* display: flex; */
    /* gap: 10px; */
    margin-top: 10px;
  }
  .pledge-buttons .pledge-down{
    padding: 10px;
  }
  
  .category-buttons {
    display: flex;
    gap: 10px;
    margin-top: 10px;
    font-size: 14px;
  }
  
  .submit-buttons {
    margin-top: 20px;
    display: flex;
    gap: 10px;
  }
  
  .upload-status {
    margin-top: 10px;
    color: #666;
  }
  .el-input__inner{
    height: 30px !important;
    line-height: 30px !important;
  }
  .h-30{
    height: 30px;
    line-height: 30px;
  }
  .sub-title{
    height: 20px;
    line-height: 20px;
    font-size: 12px;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .mb-5{
    margin-bottom: 5px;
  }
  .font-bold{
    font-weight: bold;
  }
  .f-14{
    font-size: 14px;
  }
  .f-16{
    font-size: 16px;
  }
  .input-upload {
    display: flex;
    gap: 2px;
  }
  .upload-plus{
    border: 1px dashed #ccc;
    height: 38px;
    line-height: 38px;
    padding: 0 10px;
  }
  .upload-img{
    height: 32px;
    margin-top:3px;
  }
  .logo-section{
    width: 50px;
  }
  .business-uploader{
    height: 150px;
  }
  .multi-uploader{
    width: 145px;
    height: 145px;
    line-height: 145px;
    font-size: 28px;
    border: 1px dashed #c0ccda;
    background-color: #fbfdff;
    color: #8c939d;
    text-align: center;
  }
  .multi-uploader-img{
    width: 145px;
    padding: 5px;
    border: 1px dashed #c0ccda;
  }
  .submission-font-red{
    color: red;
  }
  .font-red{
    color: red;
    width: 0px;
    display: none;
  }
  .mt-10{
    margin-top: 10px;
  }
  .font-size-20{
    font-size: 20px;
  }
  .input-upload-avatar{
    width: 50px;
    text-align: center;
  }
  .ml-20{ 
    margin-left: 20px;
  }
  .font-size-12{
    font-size: 12px;
  }
  .box-card{
    margin-bottom: 20px;
  }
.footer{
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  color: #666;
  line-height: 40px;
  height: 40px;
}
.footer a{
  color: #666;
  text-decoration: none;
}
  </style>
  


// WEBPACK FOOTER //
// src/pages/short_film/index.vue